import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/*
Fires when the User starts watching an Episode. Here are the different scenarios that
clarifies this:

• When the User first starts watching after the App has launched
• When the User changes the channel and a new Episode starts playing
• When an Episode starts naturally after the previous Episode ends on the same channel
• When the User resumes watching Live TV after being in a state when no video is playing
(e.g. after the User goes from the MyPluto section to Live TV)
• When the User starts playing a video title on VOD

The following parameters (channel_id, episode_id, clip_id) should reflect whatever the User is
watching at the moment the Event is fired.
If in VOD mode, channel_id should simply be lowercase
"vod"
 */

export const episodeStartBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.WATCH,
  eventName: EVENT_NAMES.EPISODE_START,
  ...action.payload,
});
